/**
 * CurrencyInput - Auto-formatting currency field for large bond forms
 * Formats to $X,XXX.XX on blur, strips to raw number on focus.
 * Stores raw numeric string in state, displays formatted when not focused.
 */

import { useState } from 'react';

const formatCurrency = (val) => {
  const num = parseFloat(String(val).replace(/[^\d.]/g, ''));
  if (isNaN(num)) return '';
  return num.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
};

const stripToRaw = (val) => String(val).replace(/[^\d.]/g, '');

const CurrencyInput = ({ label, value, onChange, placeholder = '0.00', required, disabled, helperText, className = '' }) => {
  const [focused, setFocused] = useState(false);

  const displayValue = focused ? value : (value ? formatCurrency(value) : '');

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        {!focused && !value && (
          <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
            <span className="text-gray-500 dark:text-gray-400">$</span>
          </div>
        )}
        <input
          type="text"
          inputMode="decimal"
          value={displayValue}
          onChange={(e) => onChange(stripToRaw(e.target.value))}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete="off"
          data-1p-ignore
          data-lpignore="true"
          className={`w-full ${!focused && !value ? 'pl-8' : 'px-4'} py-3.5 border rounded-xl text-base sm:text-sm bg-white dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-primary/20 focus:border-primary disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:cursor-not-allowed transition-all duration-200 placeholder:text-gray-400 dark:placeholder:text-gray-500 border-gray-300 dark:border-gray-600`}
        />
      </div>
      {helperText && <p className="mt-1.5 text-xs text-gray-500 dark:text-gray-400">{helperText}</p>}
    </div>
  );
};

export default CurrencyInput;
